import {useCallback, useEffect, useState} from 'react';
import moment from 'moment';
import 'moment-duration-format';
import {Button, FormControl, Grid, makeStyles, MenuItem, Select, TextField} from '@material-ui/core';
import UtilService from '../../../../../helper/service';
import {DatePicker, KeyboardTimePicker, MuiPickersUtilsProvider} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import {useDispatch, useSelector} from "react-redux";
import {editExperience, getReelSessions} from "../../../../../store/actions"
import {getSessionParticipants, onEditSubCategory} from '../../../../../store/actions/creator/creatorExperienceManager';
import CustomSnackBar from '../../../creator/experienceManager/participantsDashboard/component/CustomSnackBar';
import clsx from "clsx";
import {BackDropAnalyzeLoading, Loading} from '../../../../atoms/commonLoadings';

const darkImages = [8, 9, 12, 13, 14, 15, 16, 17, 32, 33, 36, 40, 44, 48, 49, 50, 51, 52, 54, 55, 56, 61, 65, 68, 69, 70];
const useStyles = makeStyles(() => ({
  image: {
    borderRadius: 10,
    width: '261px',
    objectFit: 'cover',
    height: '175px',
  },
  mainDiv: {
    display: 'flex',
    maxWidth: '470px',
    minWidth: '470px'
  },
  label: {
    "&$focusedLabel": {
      color: "#212D40"
    },
    "&$erroredLabel": {
      color: "#212D40"
    }
  },
  focusedLabel: {
    fontSize: 14,
    fontFamily: 'roboto-black',
  },
  erroredLabel: {},
  underline: {
    fontSize: 16,
    fontFamily: 'roboto-light',
    color: '#212D40',
  },
  error: {
    color: '#f44336',
    "&:before": {
      borderBottom: `1px solid #f44336`
    },
    "&:after": {
      borderBottom: `1px solid #f44336`
    }
  },
  normal: {
    color: '#212D40',
    "&:before": {
      borderBottom: `1px solid rgba(0, 0, 0, 0.42)`
    },
    "&:after": {
      borderBottom: `1px solid rgba(0, 0, 0, 0.42)`
    }
  },
  icon: {
    marginLeft: 4
  },
  dateModalCancelBtn: {
    backgroundColor: '#e0e0e0',
    color: 'rgba(0, 0, 0, 0.87)'
  },
  dateModalOkBtn: {
    backgroundColor: '#017AEF',
    color: '#fff'
  },
  calendarBtnLabel: {
    fontSize: 16,
    fontFamily: 'roboto-regular',
    textTransform: 'none',
    borderRadius: 4,
    minWidth: 64,
    padding: '6px 16px',
    boxShadow: '0px 3px 1px -2px rgb(0 0 0 / 20%), 0px 2px 2px 0px rgb(0 0 0 / 14%), 0px 1px 5px 0px rgb(0 0 0 / 12%)'
  },
  doneBtn: {
    margin: 0,
    padding: 0,
    height: 27,
    backgroundColor: '#0179EE',
    borderRadius: 4,
    color: '#fff',
    fontSize: 12,
    fontFamily: 'roboto-regular',
    textTransform: 'none',
    marginTop: 2,
    marginLeft: 5,
    '&:hover': {
      backgroundColor: '#0f9fef'
    }
  },
  defaultBtn:{
    height: 27,
    minWidth: 75,
    background: '#F0F0F0',
    borderRadius: 4,
    color: '#697683',
    fontFamily: 'roboto-regular',
    boxShadow: 'none',
    textTransform: 'none',
    fontSize: 12,
    marginTop: 2
  },
  startBtn: {
    height: 27,
    minWidth: 75,
    background: '#1DB859',
    borderRadius: 4,
    color: '#fff',
    fontFamily: 'roboto-regular',
    boxShadow: 'none',
    textTransform: 'none',
    fontSize: 12,
    marginTop: 2,
    marginLeft: 5,
    '&:hover': {
      background: '#1D9659'
    }
  },
  endBtn: {
    height: 27,
    minWidth: 75,
    background: '#ED564A',
    borderRadius: 4,
    color: '#fff',
    fontFamily: 'roboto-regular',
    boxShadow: 'none',
    textTransform: 'none',
    fontSize: 12,
    marginTop: 2,
    marginLeft: 5,
    '&:hover': {
      background: '#ED4F59'
    }
  },
  changeDateDiv: {
    position: 'absolute',
    top: 'calc(50% - 44px)',
    left: 'calc(50% - 24px)',
    zIndex: 1000,
    display: 'flex'
  },
  changeSubcategoryDiv: {
    position: 'absolute',
    top: 'calc(50% + 50px)',
    left: 'calc(50% - 24px)',
    zIndex: 1000,
    display: 'flex'
  },
  editIconDiv: {
    border: '1px solid #717e8b',
    borderRadius: 6,
    cursor: 'pointer',
    padding: '0px 3px 0px 0px',
    backgroundColor: '#F0F0F0'
  },
  thumbnailDiv: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    marginRight: 23,
    float: 'left',
    width:'100%',
    '@media screen and (max-width: 800px)': {
      marginRight: 0
    },
    zIndex: 0
  },
  startDateBlack: {
    position: 'absolute',
    fontSize: 18,
    fontFamily: 'Spartan-extrabold',
    color: '#212D40',
    textTransform: 'uppercase',
    left: 'calc(50% - 45px)'
  },
  startDateWhite: {
    position: 'absolute',
    fontSize: 18,
    fontFamily: 'Spartan-extrabold',
    color: '#ffffff',
    textTransform: 'uppercase',
    left: 'calc(50% - 45px)'
  },
  experienceInfo: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    flex: 3,
    position: 'relative'
  },
  mp3Icon: {
    width: '38px',
    height: '38px',
  },
  expInfoIcons: {
    width: 20,
    height: 20,
    marginRight: 10
  },
  expInfoDiv: {
    color: '#697683',
    textTransform: 'uppercase'
  },
  expInfoTitle: {
    fontFamily: 'Spartan-bold',
    fontSize: 15
  },
  expInfoSubTitle: {
    fontFamily: 'Spartan-semibold',
    fontSize: 12,
    opacity: 0.6,
    marginTop: 5
  },
  editLabel: {
    fontSize: 14,
    fontFamily: 'roboto-bold',
    color: '#212D40'
  },
  datetimePicker: {
    maxWidth: '182px'
  },
  buttonSection: {
    width: '100%',
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'space-between'
  },
  surveyLink: {
    width: 230,
    margin: 0
  },
  surveyLabel: {
    "&$focusedLabel": {
      color: "#212D40"
    },
    "&$erroredLabel": {
      color: "#212D40"
    }
  },
  surveyFocusedLabel: {
    fontSize: 10,
    fontFamily: 'roboto-black',
  },
  surveyErroredLabel: {},
  surveyUnderline: {
    fontSize: 12,
    fontFamily: 'roboto-light',
    color: '#212D40',
  },
  surveyError: {
    color: '#f44336',
    "&:before": {
      borderBottom: `1px solid #f44336`
    },
    "&:after": {
      borderBottom: `1px solid #f44336`
    }
  },
  formControl: {
    width: 300
  },
  selectMenu: {
    color: '#697683',
    fontFamily: 'roboto-light',
    fontSize: 15
  },
  timePickerInput: {
    width: '160px!important',
    '& > div': {
      fontSize: 16,
      fontFamily: 'roboto-light',
      color: '#212D40'
    },
    '& input': {
      display: 'flex',
      alignItems: 'center'
    }
  },
  timezoneStart: {
    '& input#timezoneStart::before': {
      content: (props: any) => props.start ? `"${props.start}"`: "''",
      marginLeft: 80,
      position: 'absolute'
    },
  },
  clockIcon: {
    width: '18px',
    height: '18px',
    cursor: 'pointer',
    background: 'white'
  },
}));

export default function ExperienceLength({ session }: { session: any }) {
  const { categories } = useSelector((state: any) => state.creatorExperienceManager);
  const [expLength, setExpLength] = useState<any>('Processing...');
  const [experienceStartDateTime, setExperienceStartDateTime] = useState<any>('');
  const [experienceEndDateTime, setExperienceEndDateTime] = useState<any>('');
  const [surveyLink, setSurveyLink] = useState('');

  const classes = useStyles({
    start: UtilService.getTimeZoneDate(experienceStartDateTime) !== 'Invalid date' ? UtilService.getTimeZoneDate(experienceStartDateTime) : '',
    end: UtilService.getTimeZoneDate(experienceEndDateTime) !== 'Invalid date' ? UtilService.getTimeZoneDate(experienceEndDateTime) : '',
  });

  const [validStartDate, setValidStartDate] = useState(0);
  const [validStartTime, setValidStartTime] = useState(0);
  const [validEndDate, setValidEndDate] = useState(0);
  const [validEndTime, setValidEndTime] = useState(0);

  const invalidStartDateMsg = ["", "Start Date must be later than current Date & Time"];
  const invalidStartTimeMsg = ["", "Start Time must be later than current Date & Time"];
  const invalidEndDateMsg = ["", "End Date must be later than Start Date & Time", "Duration must be longer than 5 minutes"];
  const invalidEndTimeMsg = ["", "End Time must be later than Start Date & Time", ""];

  const [allowSave, setAllowSave] = useState<boolean>(false);
  const [disableStartDate, setDisableStartDate] = useState<boolean>(true);
  const [disableEndDate, setDisableEndDate] = useState<boolean>(true);
  const [userID, setUserID] = useState<string>('');
  const [saveDateLoading, setSaveDateLoading] = useState<boolean>(false);
  const dispatch = useDispatch();
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const [editStartDate, setEditStartDate] = useState<boolean>(false);
  const [editEndDate, setEditEndDate] = useState<boolean>(false);
  const [editSurveyLink, setEditSurveyLink] = useState<boolean>(false);
  const participants = useSelector((state: any) => state.experience.participants);
  const [isShownSnackAlert, setShownSnackAlert] = useState(false);
  const { stimulus } = useSelector((state: any) => state.analysis);
  const { onlyReelSessions } = useSelector((state: any) => state.experience);
  const [reelSessionCount, setReelSessionCount] = useState<any>(0);
  const [loader, setLoader] = useState(false);
  const [message, setMessage] = useState<any>('');
  const [messageType, setMessageType] = useState<any>('');
  const [hoverEditDate, setHoverEditDate] = useState(false);
  const [hoverEditSubtype, setHoverEditSubtype] = useState(false);
  const [allowEditSubtype, setAllowEditSubtype] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedSubcategories, setSelectedSubcategories] = useState([]);
  const [selectedSubCategory, setSelectedSubCategory] = useState('');
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";

  useEffect(() => {
    if (saveDateLoading) {
      closeEditDate()
    }
  }, [participants]);

  useEffect(() => {
    if (onlyReelSessions && onlyReelSessions.reels) {
      setReelSessionCount(onlyReelSessions.reels.length)
    }
  },[onlyReelSessions]);
  
  useEffect(() => {
    if (!editStartDate && !editEndDate) {
      setExperienceStartDateTime(new Date(parseInt(setStartDate(session)) * 1000));
      setExperienceEndDateTime(new Date(parseInt(setEndDate(session)) * 1000))
    }
    if (session.session_length) {
      setExpLength(session.session_length)
    }

    if (loginUserData.user_id) {
      setUserID(loginUserData.user_id)
    }
    if (session && session['session_type'] === 'ASYNC' && session['survey_link']) {
      setSurveyLink(session['survey_link']);
    }

    const reeleq = {
      session_code: String(session.session_code),
    };
    dispatch(getReelSessions(apolloClient.client, reeleq));
  }, [session]);

  useEffect(() => {
    if (session && categories) {
      if (session['session_type'] !== 'REELS' && session['session_category'] && session['session_subcategory']) {
        onInit(session, categories);
      }
    }
  }, [session, categories]);

  const onInit = (session: any, categories: any) => {
    const session_category = session['session_category'];
    const categoryList = session.session_type === 'ASYNC' ? categories['async'] : categories['moderated'];
    setSelectedCategories(categoryList);
    if (session_category.toLowerCase() === 'other') {
      const selectedCategory = categoryList.find((item: any) => item.category.toLowerCase() === session_category.toLowerCase());
      setSelectedCategory(selectedCategory.category);
      setSelectedSubcategories([]);
      setSelectedSubCategory('')
    } else {
      const selectedCategory = categoryList.find((item: any) => item.display_category === session_category);
      if (selectedCategory && selectedCategory.category) {
        setSelectedCategory(selectedCategory.category);
        const subCategories = selectedCategory.subcategories;
        if (subCategories) {
          setSelectedSubcategories(subCategories);
          const selectionValue = subCategories.find((item: any) => item.display_subcategory === session.session_subcategory);
          if (selectionValue && selectionValue['subcategory']) {
            setSelectedSubCategory(selectionValue['subcategory']);
          } else {
            setSelectedSubCategory('')
          }
        } else {
          setSelectedSubcategories([]);
          setSelectedSubCategory('')
        }
      } else {
        setSelectedCategory('');
        setSelectedSubcategories([]);
        setSelectedSubCategory('')
      }
    }
  };

  const setStartDate = (data: any) => {
    const { session_status } = data;
    if (session_status === "UPCOMING") {
      return data.scheduled_start_at;
    } else {
      return data.session_trim_from ? data.session_trim_from : data.started_at;
    }
  };

  const setEndDate = (data: any) => {
    const { session_status } = data;
    if (session_status === "COMPLETED") {
      return data.session_trim_to ? data.session_trim_to : data.ended_at;
    } else {
      return data.scheduled_end_at;
    }
  };

  const okBtn = () => {
    return (
      <div className={clsx(classes.dateModalOkBtn, classes.calendarBtnLabel)}>
        OK
      </div>
    )
  };

  const cancelBtn = () => {
    return (
      <div className={clsx(classes.dateModalCancelBtn, classes.calendarBtnLabel)}>
        Cancel
      </div>
    )
  };

  const checkValidation = (startDateTime: Date, endDateTime: Date) => {
    let ved = 0;
    let vet = 0;
    let vsd = 0;
    let vst = 0;

    const now = new Date();
    const date1 = new Date(startDateTime.getTime());
    date1.setHours(0, 0, 0, 0);

    const date2 = new Date(endDateTime.getTime());
    date2.setHours(0, 0, 0, 0);

    ved = (date2 >= date1) ? 0 : 1;
    vet = startDateTime.getTime() < endDateTime.getTime() ? 0 : 1;

    if (startDateTime.getTime() < now.getTime()) {
      const date1 = new Date(startDateTime.getTime());
      date1.setHours(0, 0, 0, 0);

      const date2 = new Date(now.getTime());
      date2.setHours(0, 0, 0, 0);

      if (vsd === 0)
        vsd = (date1 > date2) ? 0 : 1;   // Start Date should be after now.
      if (vst === 0)
        vst = (date1 !== date2) ? 0 : 1;  // Start Time should be after now.
    }

    if ((endDateTime.getTime() - startDateTime.getTime()) < 5 * 60 * 1000) {
      if (ved === 0 && vet === 0)
        ved = 2;
      if (vet === 0)
        vet = 2;
    }

    setValidStartDate(vsd);
    setValidStartTime(vst);
    setValidEndDate(ved);
    setValidEndTime(vet);

    setAllowSave((disableStartDate || (vsd === 0 && vst === 0)) && (disableEndDate || (ved === 0 && vet === 0)));
  };

  const checkEditDateAvailability = useCallback(() => {
    if (
      session
      && session.session_status
      && (session.session_status === "UPCOMING" || session.session_status === "LIVE")
    ) {
      setHoverEditDate(true);
    }
  }, [session]);

  const onSave = useCallback(async () => {
    if (allowEditSubtype) {
      setLoader(true);
      const currentCategory = selectedCategory.toLowerCase();
      const request = {
        subcategory: currentCategory === 'other' ? 'OTHER' : selectedSubCategory,
        category: currentCategory === 'other' ? 'OTHER' : selectedCategory,
        session_id: Number(session.session_id)
      };
      dispatch(onEditSubCategory(apolloClient.client, request, (res: boolean) => {
        if (res) {
          dispatch(getSessionParticipants(apolloClient.client, { session_code: session.session_code, }, () => {
            setLoader(false);
            closeEditDate();
          }));
        }
      }));
    } else {
      if (session && experienceStartDateTime && experienceEndDateTime) {
        const request = (session['session_type'] === 'ASYNC' || session['session_type'] === 'REELS')
          ? {
            title: session.session_title ? session.session_title : "",
            description: session.session_description ? session.session_description : "",
            scheduled_start: UtilService.getDateTime(experienceStartDateTime),
            scheduled_end: UtilService.getDateTime(experienceEndDateTime),
            user_id: userID ? userID : "",
            session_id: session.session_id ? session.session_id : "",
            survey_link: surveyLink
          }
          : {
            title: session.session_title ? session.session_title : "",
            description: session.session_description ? session.session_description : "",
            scheduled_start: UtilService.getDateTime(experienceStartDateTime),
            scheduled_end: UtilService.getDateTime(experienceEndDateTime),
            user_id: userID ? userID : "",
            session_id: session.session_id ? session.session_id : ""
          };
        setSaveDateLoading(true);
        await dispatch(editExperience(apolloClient.client, request, (res: any) => {
          if (res !== null) {
            dispatch(getSessionParticipants(apolloClient.client, { session_code: session.session_code, }, () => { }));
          } else {
            closeEditDate();
          }
        }));
      }
    }
  }, [
    userID, allowEditSubtype, selectedSubCategory, selectedCategory, session,
    experienceStartDateTime, experienceEndDateTime, surveyLink
  ]);

  const saveStartEndDateNow = useCallback(async (type:any) => {
    if (session) {
      let startDate = experienceStartDateTime;
      let endDate = experienceEndDateTime;
      if (type === 'start') {
        startDate = new Date();
        startDate = new Date(startDate.getTime() + 1000 * 60);
        setMessage("Experience will start within one minute");
        setMessageType("Success");
      } else {
        endDate = new Date();
        endDate = new Date(endDate.getTime() + 1000 * 60);
        setMessage("Experience will complete within one minute");
        setMessageType("Success");
      }

      const request = {
        title: session.session_title ? session.session_title : "",
        description: session.session_description ? session.session_description : "",
        scheduled_start: UtilService.getDateTime(startDate),
        scheduled_end: UtilService.getDateTime(endDate),
        user_id: userID ? userID : "",
        session_id: session.session_id ? session.session_id : ""
      };
      setSaveDateLoading(true);
      await dispatch(editExperience(apolloClient.client, request, (res: any) => {
        if (res !== null) {
          dispatch(getSessionParticipants(apolloClient.client, { session_code: session.session_code, }, () => {
            setLoader(false);
            setShownSnackAlert(true);
          }));
        } else {
          closeEditDate();
        }
      }));
    }
  }, [session, userID]);
  
  const enableDateToEdit = () => {
    if (session) {
      if (session.session_status === "UPCOMING") {
        setDisableStartDate(false);
        setDisableEndDate(false);
        setEditStartDate(true);
        setEditEndDate(true);
        setSurveyLink(session['survey_link']);
      } else if (session.session_status === "LIVE") {
        setDisableEndDate(false);
        setDisableStartDate(true);
        setEditEndDate(true);
        setSurveyLink(session['survey_link']);
      }
    }
  };

  const onEnableEditingSubtype = useCallback(() => {
    if (session && categories) {
      setAllowEditSubtype(true);
      onInit(session, categories);
    }
  }, [session, categories]);

  const closeEditDate = () => {
    setAllowSave(false);
    setSaveDateLoading(false);
    setHoverEditDate(false);
    setHoverEditSubtype(false);
    setAllowEditSubtype(false);
    setDisableStartDate(true);
    setDisableEndDate(true);
    setEditStartDate(false);
    setEditEndDate(false);
    setEditSurveyLink(false);
    if (session) {
      setExperienceStartDateTime(new Date(parseInt(setStartDate(session)) * 1000));
      setExperienceEndDateTime(new Date(parseInt(setEndDate(session)) * 1000))
    }
  };

  const hideSnackAlert = () => {
    setShownSnackAlert(false);
  };

  const getStart = (session: any) => {
    const { session_status } = session;
    if (session_status.toLowerCase() === 'upcoming') {
      return session['scheduled_start_at']
    } else {
      return session['started_at']
    }
  };

  const getHeaderLabelColor = () => {
    if (session && session.large_thumbnail) {
      const arrayPieces = session.large_thumbnail.split(/[\s/]+/);
      if (darkImages.includes(parseInt(arrayPieces[arrayPieces.length - 1].split('.')[0].split('-')[1]))) {
        return classes.startDateWhite
      } else {
        return classes.startDateBlack
      }
    } else {
      return classes.startDateBlack
    }
  };

  const showSurveyLinkEditField = useCallback(() => {
    return session
      && session['session_type']
      && (session['session_type'] === 'ASYNC' || session['session_type'] === 'REELS')
      && session['session_status']
      && (session['session_status'] === 'UPCOMING' || session['session_status'] === 'LIVE')
      && !allowEditSubtype;
  }, [session, allowEditSubtype]);

  const onChangeSurveyLink = (event: any) => {
    setEditSurveyLink(true);
    setAllowSave(true);
    const survey_link = event.target.value;
    survey_link && setSurveyLink(survey_link)
  };

  const onLeaveMouse = () => {
    setHoverEditDate(false);
    setHoverEditSubtype(false);
  };

  const handleChangeCategory = useCallback((event: any) => {
    const value = event.target.value;
    const _selectedCategory: any = selectedCategories.find((item: any) => item.category === value);
    const _subCategories = _selectedCategory.subcategories;

    setSelectedCategory(value);
    if (value.toLowerCase() === 'other' || !_subCategories || _subCategories.length === 0) {
      setSelectedSubcategories([]);
      setSelectedSubCategory('');
    } else {
      setSelectedSubcategories(_subCategories);
      setSelectedSubCategory(_subCategories[0].subcategory);
    }
  }, [selectedCategory]);

  const handleChangeSubcategory = (event: any) => {
    setSelectedSubCategory(event.target.value);
  };

  const handleStartDateChange = (startDate: Date) => {
    setExperienceStartDateTime(startDate);
    checkValidation(startDate, experienceEndDateTime);
  };

  const getStartTimeStr = useCallback(() => {
    const time = UtilService.getLocalTime(experienceStartDateTime);
    const hour = time.getHours();
    const minute = time.getMinutes();
    return `${hour >= 10 ? hour : `0${hour}`}:${minute >= 10 ? minute : `0${minute}`}`
  }, [experienceStartDateTime]);

  const onChangeStartTime = (e: any) => {
    const timeStr = e.target.value;
    if (timeStr) {
      const hoursAndMinutes = timeStr.split(':');
      const hours = Number(hoursAndMinutes[0]);
      const minutes = Number(hoursAndMinutes[1]);
      const time = UtilService.getLocalTime(experienceStartDateTime);
      const updatedTime = time.setHours(hours, minutes);
      const reversedTime = UtilService.getLocalTimeReverse(new Date(updatedTime));
      setExperienceStartDateTime(reversedTime);
      checkValidation(reversedTime, experienceEndDateTime);
    }
  };

  const handleStartTimeChange = (startTime: Date) => {
    setExperienceStartDateTime(startTime);
    checkValidation(startTime, experienceEndDateTime);
  };

  const handleEndDateChange = (endDate: Date) => {
    setExperienceEndDateTime(endDate);
    checkValidation(experienceStartDateTime, endDate);
  };

  const getEndTimeStr = useCallback(() => {
    const time = UtilService.getLocalTime(experienceEndDateTime);
    const hour = time.getHours();
    const minute = time.getMinutes();
    return `${hour >=10 ? hour : `0${hour}`}:${minute >= 10 ? minute : `0${minute}`}`
  }, [experienceEndDateTime]);

  const onChangeEndTime = (e: any) => {
    const timeStr = e.target.value;
    if (timeStr) {
      const hoursAndMinutes = timeStr.split(':');
      const hours = Number(hoursAndMinutes[0]);
      const minutes = Number(hoursAndMinutes[1]);
      const time = UtilService.getLocalTime(experienceEndDateTime);
      const updatedTime = time.setHours(hours, minutes);
      const reversedTime = UtilService.getLocalTimeReverse(new Date(updatedTime));
      setExperienceEndDateTime(reversedTime);
      checkValidation(experienceStartDateTime, reversedTime);
    }
  };

  const handleEndTimeChange = (endTime: Date) => {
    setExperienceEndDateTime(endTime);
    checkValidation(experienceStartDateTime, endTime);
  };

  return (
    <div className="card" style={{ height: '100%', display: 'flex', alignItems: 'center' }}>
      <BackDropAnalyzeLoading loading={loader} />
      <div className={classes.mainDiv} style={{ height: (!editStartDate && !editEndDate && !allowEditSubtype) ? 'unset' : '100%' }}>
        {(!editStartDate && !editEndDate && !allowEditSubtype) && (
          <div style={{ flex: 4 }}>
            <div className={classes.thumbnailDiv}>
              <img
                alt={'Thumbnail'}
                className={classes.image}
                src={((session && session.large_thumbnail ? session.large_thumbnail : '/assets/icons/creatordashboard/empty_screen.svg'))}
              />
              {(session['large_thumbnail']?.includes('/placeholders/')) && (
                (session && session['session_type'] ==="REELS") ?
                  <span style={{textAlign: "center" }} className={getHeaderLabelColor()}>
                    REEL<br />
                    {UtilService.getOverviewExperienceStartDate(getStart(session))}
                  </span>
                  :
                  <span className={getHeaderLabelColor()}>
                    {(!stimulus && session && session['session_type'] !== 'ASYNC') && UtilService.getOverviewExperienceStartDate(getStart(session))}
                    {(stimulus && stimulus.stimulus_type === "AUDIO") && (
                      <img
                        src={`/assets/icons/mp3.svg`}
                        alt={'img'}
                        className={classes.mp3Icon}
                      />
                    )}
                  </span>
              )}
            </div>
          </div>
        )}
        <div
          className={classes.experienceInfo}
          onMouseOver={() => checkEditDateAvailability()}
          onMouseLeave={() => onLeaveMouse()}
        >
          {(hoverEditDate && !editStartDate && !editEndDate && !editSurveyLink && !hoverEditSubtype && !allowEditSubtype) && (
            <div className={classes.changeDateDiv}>
              <div className={classes.editIconDiv} style={{ marginRight: 10 }}>
                <img
                  src={'/assets/icons/experiencebuilder/edit-icon.svg'}
                  alt="Edit date"
                  title="Edit date"
                  className={classes.icon}
                  onClick={() => enableDateToEdit()}
                />
              </div>
            </div>
          )}
          {!allowEditSubtype ? (
            <>
              {!editStartDate ? (
                <div style={{ display: 'flex', opacity: (hoverEditDate && !editStartDate && !editEndDate && !hoverEditSubtype) ? 0.3 : 1 }}>
                  <img src={'/assets/icons/calendar.svg'} className={classes.expInfoIcons} />
                  <div className={classes.expInfoDiv}>
                    <div className={classes.expInfoTitle}>{ UtilService.getExpDateFormatString(setStartDate(session)) }</div>
                    <div className={classes.expInfoSubTitle}>START</div>
                  </div>
                </div>
              ) : (
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <Grid style={{ width: '100%' }}>
                    <div className={classes.editLabel}>Edit Start</div>
                    <DatePicker
                      className={classes.datetimePicker}
                      value={UtilService.getLocalTime(experienceStartDateTime)}
                      onChange={(startDate: any) => handleStartDateChange(UtilService.getLocalTimeReverse(startDate))}
                      animateYearScrolling
                      format="MMMM dd, yyyy"
                      cancelLabel={cancelBtn()}
                      okLabel={okBtn()}
                      minDate={new Date()}
                      error={validStartTime !== 0}
                      helperText={invalidStartDateMsg[validStartDate]}
                      InputLabelProps={{
                        classes: {
                          root: clsx(classes.label, validStartDate === 0 ? classes.normal : classes.error),
                          focused: classes.focusedLabel,
                          error: classes.erroredLabel
                        },
                      }}
                      InputProps={{
                        classes: {
                          root: clsx(classes.underline, validStartDate === 0 ? classes.normal : classes.error),
                          error: classes.error
                        },
                        value: (moment(UtilService.getLocalTime(experienceStartDateTime)).format('MMMM DD, yyyy'))
                      }}
                      disabled={disableStartDate}
                    />
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <TextField
                      type="time"
                      value={getStartTimeStr()}
                      error={validStartTime !== 0}
                      helperText={invalidStartTimeMsg[validStartTime]}
                      className={classes.timePickerInput}
                      InputLabelProps={{
                        shrink: true
                      }}
                      inputProps={{
                        step: 300, // 5 min
                      }}
                      onChange={onChangeStartTime}
                      id='timezoneStart'
                      InputProps={{
                        className: classes.timezoneStart,
                      }}
                    />
                    <KeyboardTimePicker
                      id="start-time-picker"
                      value={UtilService.getLocalTime(experienceStartDateTime)}
                      cancelLabel={cancelBtn()}
                      okLabel={okBtn()}
                      error={validStartTime !== 0}
                      onChange={(startTime: any) => handleStartTimeChange(UtilService.getLocalTimeReverse(startTime))}
                      KeyboardButtonProps={{
                        'aria-label': 'change time',
                      }}
                      style={{ width: 0, marginLeft: '-40px' }}
                      keyboardIcon={
                        <img
                          className={classes.clockIcon}
                          src={`/assets/icons/experiencebuilder/clock.svg`}
                          alt={'Clock'}
                        />
                      }
                      InputLabelProps={{
                        classes: {
                          root: clsx(classes.label, validStartTime === 0 ? classes.normal : classes.error),
                          focused: classes.focusedLabel,
                          error: classes.erroredLabel
                        }
                      }}
                      InputProps={{
                        classes: {
                          root: clsx(classes.underline, validStartTime === 0 ? classes.normal : classes.error),
                          error: classes.error
                        }
                      }}
                    />
                  </Grid>
                </MuiPickersUtilsProvider>
              )}
              {!editEndDate ? (
                <div style={{ display: 'flex', opacity: (hoverEditDate && !editStartDate && !editEndDate && !hoverEditSubtype) ? 0.3 : 1 }}>
                  <img src={'/assets/icons/calendar.svg'} className={classes.expInfoIcons} />
                  <div className={classes.expInfoDiv}>
                    <div className={classes.expInfoTitle}>{ UtilService.getExpDateFormatString(setEndDate(session)) }</div>
                    <div className={classes.expInfoSubTitle}>END</div>
                  </div>
                </div>
              ) : (
                <MuiPickersUtilsProvider utils={DateFnsUtils}>
                  <Grid style={{ width: '100%' }}>
                    <div className={classes.editLabel}>Edit End</div>
                    <DatePicker
                      className={classes.datetimePicker}
                      value={UtilService.getLocalTime(experienceEndDateTime)}
                      onChange={(endDate: any) => handleEndDateChange(UtilService.getLocalTimeReverse(endDate))}
                      animateYearScrolling
                      format="MMMM dd, yyyy"
                      cancelLabel={cancelBtn()}
                      okLabel={okBtn()}
                      minDate={new Date()}
                      error={validEndDate !== 0}
                      helperText={invalidEndDateMsg[validEndDate]}
                      InputLabelProps={{
                        classes: {
                          root: classes.label,
                          focused: classes.focusedLabel,
                          error: classes.erroredLabel
                        },
                      }}
                      InputProps={{
                        classes: {
                          root: clsx(classes.underline, validEndDate === 0 ? classes.normal : classes.error),
                          error: classes.error
                        },
                        value: (moment(UtilService.getLocalTime(experienceEndDateTime)).format('MMMM DD, yyyy'))
                      }}
                      disabled={disableEndDate}
                    />
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <TextField
                      type="time"
                      error={validEndTime !== 0}
                      helperText={invalidEndTimeMsg[validEndTime]}
                      value={getEndTimeStr()}
                      className={classes.timePickerInput}
                      InputLabelProps={{
                        shrink: true
                      }}
                      inputProps={{
                        step: 300, // 5 min
                      }}
                      onChange={onChangeEndTime}
                      id='timezoneStart'
                      InputProps={{
                        className: classes.timezoneStart,
                      }}
                      disabled={disableEndDate}
                    />
                    <KeyboardTimePicker
                      id="end-time-picker"
                      value={UtilService.getLocalTime(experienceEndDateTime)}
                      cancelLabel={cancelBtn()}
                      okLabel={okBtn()}
                      error={validEndTime !== 0}
                      onChange={(endTime: any) => handleEndTimeChange(UtilService.getLocalTimeReverse(endTime))}
                      KeyboardButtonProps={{
                        'aria-label': 'change time',
                      }}
                      style={{ width: 0, marginLeft: '-40px' }}
                      keyboardIcon={
                        <img
                          className={classes.clockIcon}
                          src={'/assets/icons/experiencebuilder/clock.svg'}
                          alt={'Clock'}
                        />
                      }
                      InputLabelProps={{
                        classes: {
                          root: clsx(classes.label, validEndTime === 0 ? classes.normal : classes.error),
                          focused: classes.focusedLabel,
                          error: classes.erroredLabel
                        }
                      }}
                      InputProps={{
                        classes: {
                          root: clsx(classes.underline, validEndTime === 0 ? classes.normal : classes.error),
                          error: classes.error
                        }
                      }}
                      disabled={disableEndDate}
                    />
                  </Grid>
                </MuiPickersUtilsProvider>
              )}
              {(!editStartDate && !editEndDate) && (
                <>
                  <div style={{ display: 'flex', opacity: (hoverEditDate && !editStartDate && !editEndDate && !hoverEditSubtype) ? 0.3 : 1 }}>
                    <img src={'/assets/icons/participant/clock-deactive.svg'} className={classes.expInfoIcons} />
                    <div className={classes.expInfoDiv} style={{ textTransform: 'unset' }}>
                      <div className={classes.expInfoTitle}>
                        {session.session_type === "REELS" ?
                          (reelSessionCount && reelSessionCount >= 2) ? (reelSessionCount+ "  Videos" )  : "REEL"
                          :
                          expLength === 'Processing...' ? 'Processing...' : UtilService.getExperienceLength(parseInt(expLength))
                        }
                      </div>
                      <div className={classes.expInfoSubTitle}>LENGTH</div>
                    </div>
                  </div>
                  <div
                    onMouseOver={() => (session['session_type'] !== 'REELS' && session ['session_category'] && session['session_subcategory']) && setHoverEditSubtype(true)}
                    onMouseLeave={() => setHoverEditSubtype(false)}
                  >
                    {(hoverEditSubtype && !allowEditSubtype && session['session_type'] !== 'REELS' && session ['session_category'] && session['session_subcategory']) && (
                      <div className={classes.changeSubcategoryDiv}>
                        <div className={classes.editIconDiv}>
                          <img
                            src={'/assets/icons/experiencebuilder/edit-icon.svg'}
                            alt="Edit subtype"
                            title="Edit subtype"
                            className={classes.icon}
                            onClick={() => onEnableEditingSubtype()}
                          />
                        </div>
                      </div>
                    )}
                    <div style={{ display: 'flex', opacity: hoverEditSubtype ? 0.3 : 1 }}>
                      <img src={'/assets/icons/overview/overview_subtype.svg'} className={classes.expInfoIcons} />
                      <div className={classes.expInfoDiv}>
                        <div className={classes.expInfoTitle}>
                          {session['session_type'] === 'REELS' ? 'Reel' : (session.session_subcategory ? session.session_subcategory : '--')}
                        </div>
                        <div className={classes.expInfoSubTitle}>EXP. TYPE</div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </>
          ) : (
            <>
              <Grid style={{ width: '100%' }}>
                <div className={classes.editLabel}>Experience Category</div>
                <FormControl className={classes.formControl}>
                  <Select
                    labelId="select-sub-category-label"
                    id="select-sub-category"
                    value={selectedCategory}
                    onChange={handleChangeCategory}
                  >
                    {selectedCategories.map((item: any, index: number) =>
                      <MenuItem key={index} value={item.category} className={classes.selectMenu}>
                        <span className={classes.selectMenu}>{item.display_category}</span>
                      </MenuItem>
                    )}
                  </Select>
                </FormControl>
              </Grid>
              <Grid style={{ width: '100%' }}>
                <div className={classes.editLabel}>Experience Subcategory</div>
                <FormControl className={classes.formControl}>
                  <Select
                    labelId="select-sub-category-label"
                    id="select-sub-category"
                    value={selectedSubCategory}
                    onChange={handleChangeSubcategory}
                  >
                    {selectedSubcategories.map((item: any, index: number) =>
                      <MenuItem key={index} value={item.subcategory} className={classes.selectMenu}>
                        <span className={classes.selectMenu}>{item.display_subcategory}</span>
                      </MenuItem>
                    )}
                  </Select>
                </FormControl>
              </Grid>
            </>
          )}
          {((editStartDate || editEndDate || editSurveyLink) || allowEditSubtype) && (
            <div className={classes.buttonSection}>
              <div style={{ textAlign: 'left'}}>
                <Button className={classes.defaultBtn} onClick={() => closeEditDate()} size="small">
                  Cancel
                </Button>
                {!allowEditSubtype && (
                  <>
                    {
                      session.session_type === 'ASYNC' ?
                        (session.session_status && session.session_status == 'UPCOMING') && !allowSave && stimulus && (stimulus.stimulus_status === 'READY') &&
                        <Button className={classes.startBtn} onClick={() => saveStartEndDateNow('start')} size="small">
                          Start Now
                          {saveDateLoading && <Loading style={{ width: 37, height: 37 }}/>}
                        </Button>
                        :
                        (session.session_status && session.session_status == 'UPCOMING') && !allowSave &&
                        <Button className={classes.startBtn} onClick={() => saveStartEndDateNow('start')} size="small">
                          Start Now
                          {saveDateLoading && <Loading style={{ width: 37, height: 37 }} />}
                        </Button>
                    }
                    {
                      session.session_type === 'ASYNC' ?
                        (session.session_status && session.session_status == 'LIVE') && !allowSave && stimulus && (stimulus.stimulus_status === 'READY') &&
                        <Button className={classes.endBtn} onClick={() => saveStartEndDateNow('end')} size="small">
                          End Now
                          {saveDateLoading && <Loading style={{ width: 37, height: 37 }} />}
                        </Button>
                        :
                        (session.session_status && session.session_status == 'LIVE') && !allowSave &&
                        <Button className={classes.endBtn} onClick={() => saveStartEndDateNow('end')} size="small">
                          End Now
                          {saveDateLoading && <Loading style={{ width: 37, height: 37 }}/>}
                        </Button>
                    }
                  </>
                )}
                {(allowSave || allowEditSubtype) && (
                  <Button className={classes.doneBtn} onClick={() => onSave()} size="small">
                    Save
                    {saveDateLoading && <Loading style={{ width: 37, height: 37 }}/>}
                  </Button>
                )}
              </div>
              {showSurveyLinkEditField() && (
                <TextField
                  className={classes.surveyLink}
                  InputLabelProps={{
                    classes: {
                      root: classes.surveyLabel,
                      focused: classes.surveyFocusedLabel,
                      error: classes.surveyErroredLabel
                    },
                  }}
                  InputProps={{
                    classes: {
                      root: classes.surveyUnderline,
                      error: classes.surveyError
                    }
                  }}
                  margin="dense"
                  defaultValue={surveyLink}
                  id="surveyLink"
                  label="Survey Link"
                  name="surveyLink"
                  onChange={onChangeSurveyLink}
                />
              )}
            </div>
          )}
        </div>
      </div>
      <CustomSnackBar type={messageType} message={message} open={isShownSnackAlert} onClose={hideSnackAlert} />

    </div>
  );
}

